import { render } from "./Account.vue?vue&type=template&id=037c54a6&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=037c54a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-037c54a6"

export default script